import { render, staticRenderFns } from "./ValidateCourses.vue?vue&type=template&id=4f52d54c&scoped=true&"
import script from "./ValidateCourses.vue?vue&type=script&lang=js&"
export * from "./ValidateCourses.vue?vue&type=script&lang=js&"
import style0 from "./ValidateCourses.vue?vue&type=style&index=0&id=4f52d54c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f52d54c",
  null
  
)

export default component.exports